import { abortTimeout, withAbortListener } from "@redotech/util/abort";
import { Condition } from "@redotech/util/condition";
import { Resource } from "@redotech/util/resource";

const INPUT_TIMEOUT = Temporal.Duration.from({ seconds: 2 });

export async function hidInputReport(
  device: HIDDevice,
): Promise<HIDInputReportEvent> {
  const condition = new Condition<HIDInputReportEvent>();

  const listener = (event: HIDInputReportEvent) => {
    condition.resolve(event);
  };

  device.addEventListener("inputreport", listener);
  try {
    return await withAbortListener(
      abortTimeout(INPUT_TIMEOUT),
      condition.reject,
    )(() => withHidDevice(device)(() => condition.result));
  } finally {
    device.removeEventListener("inputreport", listener);
  }
}

/**
 * Open a HID device.
 */
export function withHidDevice(device: HIDDevice): Resource<void> {
  return async (fn) => {
    if (device.opened) {
      return await fn();
    }
    await device.open();
    try {
      return await fn();
    } finally {
      try {
        await device.close();
      } catch {
        // empty
      }
    }
  };
}
